<template>
    <TopicGroup>
        <hands-on/>
        <perpetuating-innovation/>
        <template v-slot:animations>
            <hands-on-animation :delay="0" :interval="10000"/>
            <perpetuating-innovation-animation :delay="0" :interval="10000"/>
        </template>
    </TopicGroup>
</template>

<script>
import TopicGroup from '../TopicGroup'
import { empowerment } from '@/assets/svg-components'
import { empowermentAnimations } from '../TopicAnimations'

export default {
    components: {
        TopicGroup,
        ...empowerment,
        ...empowermentAnimations
    }
}
</script>

